import React from 'react';
import PropTypes from 'prop-types';

const FormError = ({ children, className }) => (
  <span className={`form__error ${className}`} data-test="form_error">
    {children}
  </span>
);

FormError.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

FormError.defaultProps = {
  children: null,
  className: '',
};

export default FormError;
